import { applyMiddleware, createStore } from 'redux';
import { loadState, saveState } from './localStorage';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import reducers from 'state/reducers';
import throttle from 'lodash/throttle';
import thunk from 'redux-thunk';

const persistedState = loadState();
if (persistedState) delete persistedState.session;

const middleware = [thunk];

let devLogger = null;
if (import.meta.env.DEV) {
    try {
        const mod = await import('redux-logger');
        devLogger = mod?.logger || mod?.default || null;
    } catch (err) {
        // ignore missing logger in dev
    }
}

if (devLogger) {
    middleware.push(devLogger);
}

const store = createStore(
    reducers,
    persistedState,
    composeWithDevTools(applyMiddleware(...middleware)),
);

store.subscribe(
    throttle(() => {
        const { tours, mode } = store.getState();
        saveState({ tours, mode });
    }, 1000),
);

const configuredStore = store;
export default configuredStore;
